import { Actions, StateChanges } from './stateChanges'
import { StoreConfig } from './storeConfig'
import axios from 'axios'
import backendRedirect from '../../backendRedirect'

const serverUrl = StoreConfig.serverUrl
const baseUrl = backendRedirect.synopsisApiTrafficManager + '/synopsis'
const urlExtend = '/api/synopsis'
const urlUpload = '/uploadfile'

/* axios.defaults.headers = {
  'Content-Type': 'text/plain;charset=UTF-8'
} */
const axiosInstance = axios.create({ timeout: 60000 })
var source

export default {
  [Actions.RUN_FOOTNOTES]: function ({ commit, state }) {
    if (source) {
      source.cancel()
    }
    const CancelToken = axios.CancelToken
    source = CancelToken.source()
    commit(StateChanges.FOOTNOTES_RUNNING)
    let textForApi = state.textForApiCall
    //let directMatch = state.directMatch
    if (textForApi) {
      //data:  textForApi
      let minthreshold = state.minRange
      axiosInstance.post(serverUrl + '/findincorpus?minthreshold=' + minthreshold + '&maxdistance=4', 'text=' + textForApi, { cancelToken: source.token })
        .then(function (response) {
          commit(StateChanges.SET_FILE_TXT_RESULTS, response.data.txt)
          commit(StateChanges.SET_FILE_DOC_RESULTS, response.data.docx)
          commit(StateChanges.SET_DATA, response.data.results)
          //if (response.data.results[0].numParallels > 0)
          //else
          commit(StateChanges.FOOTNOTES_COMPLETE)
        })

        .catch(function (error) {

          commit(StateChanges.SET_SERVER_ERROR_MESSAGE, {})
          if (axios.isCancel(error)) {
            //commit(StateChanges.FOOTNOTES_COMPLETE)
          } else {
            if (error.code === 'ECONNABORTED') {
              commit(StateChanges.SERVER_TIMED_OUT)
              //
            } else {
              if (error.response.data.length > 0 || error.response.data.error.includes('A potentially dangerous Request.Form value was detected from the client'))
                commit(StateChanges.SET_SERVER_ERROR_MESSAGE,
                  { he: 'נא להזין טקסטים בעברית בלבד.', eng: 'Please enter or upload Hebrew text to search for Parallels.' })
              commit(StateChanges.SERVER_FAILED)
            }
          }
        })
    } else {
      console.log('Invalid input.')
    }
  },
  [Actions.RUN_SYNOPSIS]: function ({ state, commit }) {
    commit(StateChanges.SYNOPSIS_RUNNING)
    let groupedData = state.dataForSynopsis
      
   
    let dataArr = [{
      content: groupedData[0].baseMatchedText,
      id: 'טקסט מקור'
    }]
    // dataArr.push({ content: group[0].baseMatchedText, id: '' })
    groupedData.map(row => {
      let obj = {}
      obj.content = row.compMatchedText.substring(row.compStartChar, row.compStartChar + row.compTextLength)
      obj.id = row.compNameHe
      dataArr.push(obj)
    })
    let data = {
      "witnesses": dataArr
    }
    axiosInstance.post(baseUrl + urlExtend + urlUpload + '/0').then((response) => {
      let sessionId = response.data.id
      let url = baseUrl + urlExtend + urlUpload + '/' + sessionId
      let formData = new FormData()
      formData.append('file', new Blob(['{"AllowOutliers":"true",  "Grouping":"None"}']), 'synopsis.settings.json', { type: 'text/plain' })
      const httpClient = axios.create()
      httpClient.defaults.timeout = 45000
      httpClient.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(() => {
        axiosInstance.post(url).then((response) => {

          let dataId = response.data.id
          let fileName, fileData
          let formData = new FormData()
          fileName = 'CollateX.json'
          fileData = JSON.stringify(data)
          var blob = new Blob([fileData], { type: 'text/plain' });
          formData.append('file', blob, fileName, { type: 'text/plain' })

          //axiosInstance.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((response) => {
          const httpClient = axios.create()
          httpClient.defaults.timeout = 45000
          httpClient.post(baseUrl + urlExtend + urlUpload + '/' + dataId, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(() => { //send data as file
            httpClient.post(baseUrl + urlExtend + '/' + dataId, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((response) => { //send data as file
              commit(StateChanges.SET_SYNOPSIS_FILE_RESULTS, response.data.top_items_alignment)
              commit(StateChanges.SYNOPSIS_COMPLETE)

            }).catch(error => {
              console.log(error)
              if (error.code === 'ECONNABORTED') {
                commit(StateChanges.SYNOPSIS_SERVER_TIMED_OUT)
              } else {
                commit(StateChanges.SYNOPSIS_SERVER_FAILED)
              }
            })

          }).catch(error => {
            console.log(error)
            if (error.code === 'ECONNABORTED') {
              commit(StateChanges.SYNOPSIS_SERVER_TIMED_OUT)
            } else {
              commit(StateChanges.SYNOPSIS_SERVER_FAILED)
            }
          })
        }).catch(error => {
          console.log(error)
          if (error.code === 'ECONNABORTED') {
            commit(StateChanges.SYNOPSIS_SERVER_TIMED_OUT)
          } else {
            commit(StateChanges.SYNOPSIS_SERVER_FAILED)
          }
        })
      }).catch(error => {
        console.log(error)
        if (error.code === 'ECONNABORTED') {
          commit(StateChanges.SYNOPSIS_SERVER_TIMED_OUT)
        } else {
          commit(StateChanges.SYNOPSIS_SERVER_FAILED)
        }
      })
    }).catch(error => {
      console.log(error)
      if (error.code === 'ECONNABORTED') {
        commit(StateChanges.SYNOPSIS_SERVER_TIMED_OUT)
      } else {
        commit(StateChanges.SYNOPSIS_SERVER_FAILED)
      }
    })
  }
}
